<template>
  <div>
    <filters
      @updateDateFrom="updateFilterData('dateFrom', $event)"
      @updateDateTo="updateFilterData('dateTo', $event)"
      @updateSelectedWarehouse="updateFilterData('warehouse', $event)"
    />

    <catalog-table
      ref="recordsTable"
      large-content
      :table-data="fetchedData"
      :pagination-info="paginationInfo"
      :tableHeaders="headers"
      :propsToSearch="searchableProps"
      :loading="loading"
      :loading-content-props="loadingProps"
      :dummy-search="true"
      :page-size="currentPageSize"
      @pageUpdated="currentPage = $event"
      @updatedSearchQuery="filterData.searchQuery = $event"
      @updatedPageSize="currentPageSize = $event"
    >
      <div
        v-if="$can('download_report', 'Sinister', 'sinister')"
        slot="search-toolbar-actions"
        class="md-group"
      >
        <md-button class="md-info" @click="downloadReport">Descargar reporte</md-button>
      </div>
      <div slot="supplyName-cell" slot-scope="{ item, value }" class="text-left">
        {{ value }}
        <md-icon v-if="item.hasConfig" style="font-size: 1.6rem !important">
          settings
          <md-tooltip md-direction="top">
            <p>Tiene configuración en el almacén</p>
          </md-tooltip>
        </md-icon>
      </div>
      <div slot="cu-cell" slot-scope="{ item, value }" class="text-left">{{ value | money }}</div>
      <div slot="subtotal-cell" slot-scope="{ item, value }" class="text-center">{{ value | money }}</div>
      <div slot="oc-cell" slot-scope="{ item, value }" class="text-left">
        <p v-if="value.length" class="supplyDetails-text" @click="supplyDetails(item)">
          {{ value[0] }}
          <span v-if="value.length > 1">+</span>
        </p>
        <p v-else>Sin OC</p>
      </div>
    </catalog-table>
    <OCDetailsModal
      v-if="showOCDetails"
      @close="showOCDetails = false"
      :currentOCs="currentOCs"
      :currentSupplyName="currentSupplyName"
    ></OCDetailsModal>
  </div>
</template>

<script>
import { CatalogTable, FileField } from "@/components/";
import Filters from "./Filter";
import OCDetailsModal from "./OCDetailsModal";
import SinisterInfo from "@/pages/RoadSinisters/File/ConceptsValidation/SinisterInfo";

// import catalogService from '@/services/catalog'
import warehouseService from "@/services/purchase/warehouse";

import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import { downloadFile } from "@/utils";
import { mapPermissions } from "@/plugins/accountPermissions";
import moment from "moment";

import { debounce } from "lodash";

export default {
  name: "InvetoryLogIndex",
  components: {
    CatalogTable,
    Filters,
    SinisterInfo,
    FileField,
    OCDetailsModal,
  },

  mixins: [usesAccountInfoMixin],

  data() {
    return {
      filterData: {
        dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        warehouse: null,
        searchQuery: null, //  para la búsqueda en la tabla (back)??
      },
      // catalogs: {
      //   highways: [],
      // },
      currentPage: 1,
      showOCDetails: false,
      currentSupplyName: null,
      currentOCs: [],
      currentPageSize: 25,
      paginationInfo: null,
      infoValidation: false,
      loading: null,
      loadingSaving: null,
      currentSinister: {},
      fetchedData: [],
      headers: {
        code: "Código",
        supplyName: "Insumo",
        unitMeasurement: "Unidad de Medida",
        oc: "OC origen",
        currentStock: "Cantidad Disponible",
        assignedStock: "Cantidad Apartada",
        physicalStock: "Cantidad en Almacén",
        cu: "CU",
        subtotal: "Subtotal",
      },
      searchableProps: ["supplyName"],
      actions: [
        {
          icon: "edit",
          exe: this.editRoadSinister,
          ifUserCan: {
            change: "Roads/sinisterroads",
          },
          tooltip: "Editar movimiento",
        },
      ],
      loadingProps: {
        emptyLabel: "No hay siniestros que mostrar.",
        emptyDescription: "Intente más tarde o redefina su consulta.",
      },
    };
  },

  computed: {
    ...mapPermissions("Roads", "sinisterroads"),
    // ...mapState("catalogs", {
    //   rawProcesses: (state) => state["macro/Carreteras/process"],
    // }),
    fetchParams() {
      const filtersParams = this.filtersParams;
      const searchQuery = this.filterData.searchQuery;

      return { ...filtersParams, searchQuery };
    },
    filtersParams() {
      // const page = this.currentPage;
      const pageSize = this.currentPageSize;
      const from = this.filterData.dateFrom;
      const to = this.filterData.dateTo;
      const warehouse = this.filterData.warehouse;

      return {
        // page,
        pageSize,
        from,
        to,
        warehouse,
      };
    },
  },

  watch: {
    "filterData.searchQuery": debounce(function () {
      this.currentPage = 1;
      this.fetchData().then(() => {
        if (this.$refs.recordsTable) {
          this.$refs.recordsTable.focusSearch();
        }
      });
    }, 500),
    filtersParams: debounce(function () {
      this.fetchData();
    }, 500),
    // "paginationInfo.previous": function (value) {
    //   this.currentPage = (value || 0) + 1;
    // },
    // currentPageSize() {
    //   this.currentPage = 1;
    // },
    // paginationInfo(value) {
    //   this.$emit("update:paginationInfo", value);
    // },
  },

  methods: {
    fetchData() {
      this.loading = true;
      return warehouseService
        .fetchStockReport(this.fetchParams)
        .then((resp) => {
          this.fetchedData = resp;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    supplyDetails(supply) {
      const { supplyName, code, oc } = supply;
      this.currentSupplyName = `${code} - ${supplyName}`;
      this.currentOCs = oc;
      this.showOCDetails = true;
    },
    downloadReport() {
      const { warehouse } = this.filterData;
      downloadFile(
        `iwarehouse/report/stock-warehouse/`,
        "reporte_existencia_almacen.xls",
        {
          config: {
            params: {
              type: "xls",
              warehouse,
              xml: true,
            },
          },
        }
      )
        .then(() => {
          this.$notify({
            message: "Descargando archivo.",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(this.$fireErrorResponse);
    },
    updateFilterData(item, value) {
      this.currentPage = 1;
      this.filterData[item] = value;
    },
    openChecksValidation(sinister) {
      this.currentSinister = sinister;
      this.infoValidation = true;
    },
    closeValidate() {
      this.infoValidation = false;
      this.checklist = this.checklist.map((c) => ({ ...c, checked: false }));
    },
    processIsSmallerThan(sinister, processAbbre) {
      const { processes, processNumber } = sinister;
      const process = processAbbre.replace(/[()]/g, "");
      const simpAbbre = trimParenthesis(process).toLowerCase();
      const proc = processes.find(({ code }) => code === simpAbbre);
      return proc ? processNumber < proc.number : false;
    },
    sendRequirementsValidation() {},
    editFile(file, item) {
      this.loadingSaving = true;
    },
    seeFile(file) {
      const win = window.open(file, "_blank");
      win.focus();
    },
  },
};
</script>

<style lang="less" scoped>
.file-indicator {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  div {
    margin: 0 10px;
    max-width: 50px;
    text-align: center;
    align-content: center;
    height: 100%;
    p {
      margin: 0;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.supplyDetails-text:hover {
  cursor: pointer;
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/InventoryLog/Index.vue